import { render } from "./MenuSiConfigurationAffiliate.vue?vue&type=template&id=03759300&scoped=true"
import script from "./MenuSiConfigurationAffiliate.vue?vue&type=script&lang=js"
export * from "./MenuSiConfigurationAffiliate.vue?vue&type=script&lang=js"

import "./MenuSiConfigurationAffiliate.vue?vue&type=style&index=0&id=03759300&scoped=true&lang=css"

import exportComponent from "/home/kitrin/builds/isoevolve/20261004-205117/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03759300"]])

export default __exports__